var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StepType } from "@common/enums/base";
import { observable, action, computed, autorun, runInAction } from "mobx";
var progressStore = /** @class */ (function () {
    function progressStore() {
        var _this = this;
        this.stepFlows = [
            StepType.Problem,
            StepType.Detail,
            StepType.Question,
            StepType.Availability,
            StepType.Review,
            StepType.Submitted,
        ];
        this.step = StepType.Problem;
        this.reviewMode = false;
        autorun(function () {
            if (_this.step === StepType.Review) {
                runInAction(function () {
                    _this.reviewMode = true;
                });
            }
        });
    }
    Object.defineProperty(progressStore.prototype, "currentIndex", {
        get: function () {
            var _this = this;
            return this.stepFlows.findIndex(function (step) { return step === _this.step; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(progressStore.prototype, "steps", {
        get: function () {
            var _this = this;
            var steps = [
                { id: StepType.Problem, name: "Problem", checked: false },
                { id: StepType.Detail, name: "Details", checked: false },
                { id: StepType.Question, name: "Questions", checked: false },
                { id: StepType.Availability, name: "Availability", checked: false },
                { id: StepType.Review, name: "Review", checked: false },
            ];
            // if (this.reviewMode) {
            //   return steps.map((x) => {
            //     return { ...x, checked: true };
            //   });
            // }
            return steps.map(function (x, index) {
                if (index < _this.currentIndex)
                    return __assign(__assign({}, x), { checked: true });
                return __assign({}, x);
            });
        },
        enumerable: false,
        configurable: true
    });
    progressStore.prototype.back = function () {
        this.step = this.stepFlows[this.currentIndex - 1];
    };
    progressStore.prototype.next = function () {
        this.step = this.stepFlows[this.currentIndex + 1];
    };
    progressStore.prototype.jump = function (step) {
        this.step = step;
    };
    __decorate([
        observable
    ], progressStore.prototype, "step", void 0);
    __decorate([
        observable
    ], progressStore.prototype, "reviewMode", void 0);
    __decorate([
        computed
    ], progressStore.prototype, "currentIndex", null);
    __decorate([
        computed
    ], progressStore.prototype, "steps", null);
    __decorate([
        action.bound
    ], progressStore.prototype, "back", null);
    __decorate([
        action.bound
    ], progressStore.prototype, "next", null);
    __decorate([
        action.bound
    ], progressStore.prototype, "jump", null);
    return progressStore;
}());
export default progressStore;
